import caracteristiques from '@/model/caracteristiquesGraines'
import graineApi from '@/api/graine.api'

const getDefaultState = () => {
  return {
    graineRs3: {
      code: null,
      libelle: null,
      caracteristiquesPrincipales: [],
      caracteristiquesSecondaires: []
    },
    grainesContractualiseesEtRecoltees: []
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    graineRs3 (state) {
      return state.graineRs3
    },
    grainesContractualiseesEtRecoltees (state) {
      return state.grainesContractualiseesEtRecoltees
    }
  },

  mutations: {
    UPDATE_GRAINE_RS3 (state, graineRs3) {
      state.graineRs3 = graineRs3
    },
    UPDATE_GRAINES_CONTRACTUALISEES_ET_RECOLTEES (state, grainesContractualiseesEtRecoltees) {
      state.grainesContractualiseesEtRecoltees = grainesContractualiseesEtRecoltees
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    selectCodeIdaRs3 ({ commit, rootGetters }, codeIdaRs3) {
      // on récupère la graine Rs3 depuis l'enum ou on l'a crée avec des valeurs par défaut si elle n'est pas connue

      let graineRs3 = null
      if (codeIdaRs3 === 'TOTAL') {
        graineRs3 = {
          code: 'TOTAL',
          libelle: 'Toutes mes graines',
          caracteristiquesPrincipales: [],
          caracteristiquesSecondaires: []
        }
      } else {
        graineRs3 = rootGetters['application/grainesRs3'].find(g => g.code === codeIdaRs3) || {
          code: codeIdaRs3,
          libelle: codeIdaRs3,
          caracteristiquesPrincipales: [caracteristiques.humiditeTaux, caracteristiques.impureteTaux],
          caracteristiquesSecondaires: []
        }
      }
      commit('UPDATE_GRAINE_RS3', graineRs3)
    },
    getGrainesContractualiseesEtRecoltees ({ commit, rootGetters }, anneeRecolte) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return graineApi.getGrainesContractualiseesEtRecoltees(username, anneeRecolte)
        .then(result => {
          commit('UPDATE_GRAINES_CONTRACTUALISEES_ET_RECOLTEES', result)
          return result
        })
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
